








































import {Component, Prop, Watch} from "vue-property-decorator";
import AsiListTable from "@/components/common/AsiListTable.vue";
import IAsiListTableImplementation from "@/components/common/IAsiListTableImplementation";
import OrderListEntry from "@/models/order/OrderListEntry";
import OrderListFilter from "@/models/order/OrderListFilter";
import AsiListTableHeader from "@/components/common/AsiListTableHeader";
import AsiListTableOptions from "@/components/common/AsiListTableOptions";
import PaginatedResponse from "@/models/PaginatedResponse";
import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
import AsiListTableLayout from "@/components/common/AsiListTableLayout.vue";
import AsiDatePicker from "@/components/common/AsiDatePicker.vue";
import AsiTextFieldSimple from "@/components/common/AsiTextFieldSimple";
import {CompanyType, Permissions} from "@/helpers/constants";
import {getCompanyIcon} from "@/helpers/functions_td";
import Company from "@/models/company/Company";
import AsiAvatar from "@/components/common/AsiAvatar.vue";
import CompanySimple from "@/models/company/CompanySimple";

@Component({
	components: {AsiAvatar, AsiTextFieldSimple, AsiDatePicker, AsiContentContainer, AsiListTableLayout}
})
export default class OrderList extends AsiListTable<OrderListEntry, OrderListFilter> implements IAsiListTableImplementation<OrderListEntry, OrderListFilter> {

	@Prop({type: Object, default: null})
	public company!: Company | null;

	@Prop({type: Boolean, default: false})
	public hideToolbar!: boolean;

	public constructor() {
		super();
		this.filterModel = this.createFilterModel();
	}

	private get dateRange(): string[] | null {
		if (this.filterModel === null) return null;
		const ret = [];
		if (this.filterModel.dateFrom !== null) ret.push(this.filterModel.dateFrom);
		if (this.filterModel.dateTo !== null) ret.push(this.filterModel.dateTo);
		return ret;
	}

	private set dateRange(value: string[] | null) {
		if (this.filterModel === null) return;
		this.filterModel.dateFrom = value === null ? null : (value[0] ?? null);
		this.filterModel.dateTo = value === null ? null : (value[1] ?? null);
	}

	private get isInternal(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightInternal);
	}

	public mounted(): void {
		this.tableOptions.sortBy = ['name'];
		this.tableOptions.sortDesc = [false];
	}

	public createFilterModel(): OrderListFilter {
		return new OrderListFilter();
	}

	public createHeaders(): AsiListTableHeader[] {
		const columns = [
			new AsiListTableHeader(this.$t('order.name').toString(), 'name', true, true, 'start'),
			new AsiListTableHeader(this.$t('uiTerms.dateFrom').toString(), 'dateFrom', true, true, 'center', '15%'),
			new AsiListTableHeader(this.$t('uiTerms.dateTo').toString(), 'dateTo', true, true, 'center', '15%'),
		];
		if (this.company === null) {
			columns.unshift(
				new AsiListTableHeader('', 'avatar', false, false, 'center', '4rem'),
				new AsiListTableHeader(this.$t('company.singular').toString(), 'company', true, true, 'start', '20%')
			);
		}
		return columns;
	}

	public fetchData(filterModel: OrderListFilter | null, tableOptions: AsiListTableOptions | null): Promise<PaginatedResponse<OrderListEntry>> {
		if (this.company !== null) {
			return this.$companyService.orders(this.company.id, filterModel, tableOptions);
		}

		return this.$orderService.orders(filterModel, tableOptions);
	}

	public filterTextChanged(filterText: string): void {
		if (this.filterModel === null) return;
		this.filterModel.fulltext = filterText;
	}

	public openModelDetailPage(model: OrderListEntry): void {
		this.$router.push({name: 'Order', params: {id: model.id}})
	}

	public reload(goToFirstPage: boolean = false): void {
		this.reloadInternal(this, goToFirstPage);
	}

	protected companyTypeIcon(type: CompanyType): string {
		return getCompanyIcon(type);
	}

	protected avatarUrl(company: CompanySimple): string | null {
		return CompanySimple.avatarUrlMedium(company);
	}

	private formatDate(date: string | null) {
		if (date === null) return '-';

		return this.$d(new Date(date), 'short');
	}

	@Watch('tableOptions', {deep: true})
	private onTableOptionsChanged(): void {
		this.reload();
	}

	@Watch('filterModel', {deep: true})
	private onFilterModelChanged(): void {
		this.reload(true);
	}

}
